import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class InventoryProductionBatchesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCheckRecipeStock(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/create/check-recipe-stock' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/inventory-production-batches/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getRecord(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/' + id + '/record' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async record(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/record' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getReverseLots(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/' + id + '/record/reverse' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async reverseRecord(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/record/reverse' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async addInput(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/inventory-production-batches/' + id + '/inputs' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async deleteInput(id, inputId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/inventory-production-batches/' + id + '/inputs/' + inputId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getAutoFill(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventory-production-batches/' + id + '/record/auto-fill' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async autoFill(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/record/auto-fill' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/inventory-production-batches/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async confirm(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/confirm' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async start(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/start' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async complete(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/complete' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancel(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventory-production-batches/' + id + '/cancel' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const InventoryProductionBatches = new InventoryProductionBatchesApi();
